<div class="card card-skinny">
  <div class="card-header" [ngStyle]="{'background-image': 'url('+ courseGroup.thumbnailUrl + ')'}" (click)="go()">
    <!--<div class="lock" *ngIf="!purchased"></div>-->
  </div>
  <div class="card-footer">
    <div class="course-progress-container course-progress-container_white" *ngIf="purchased">
    </div>
    <div class="course-progress-container" *ngIf="purchased">
      <div class="course-progress-bar" *ngIf="courseGroup.primaryCourse"
        [ngStyle]="{width:(100 * courseGroup.primaryCourse?.progress?.watchedVideos/courseGroup.primaryCourse.progress?.totalVideos) + '%'}">
      </div>
    </div>
    <div class="card-footer-button">
      @if (!purchased) {
        @if (courseGroup.courses[0].inCoursePurchaseEnabled) {
          <a class="btn btn-no-padding" (click)="onBuyClick($event, courseGroup.courses[0])"
            [innerText]="courseGroup.courses[0].buyLinkText"></a>
        } @else {
          <a class="btn btn-no-padding"
            [href]="courseGroup.courses[0].webPurchaseUrl"
            [innerText]="courseGroup.courses[0].buyLinkText"></a>
        }
      }
      <a class="btn btn-no-padding" *ngIf="courseGroup.primaryCourse"
        (click)="openCourse(courseGroup.primaryCourse, courseGroup.primaryCourse?.progress?.userCourse)">Launch
        Course</a>
      <a class="btn btn-no-padding"
         id="LTF"
         *ngIf="!courseGroup.primaryCourse" (click)="openModal()">
        <span *ngIf="purchased">Launch Course</span>
        <span *ngIf="!purchased">Preview</span>
      </a>
    </div>
  </div>
</div>
